import React, { useState, useEffect } from 'react'
import { useAppContext } from '../context/AppContext'
import { useNavigate, useLocation } from 'react-router-dom'
import { useLanguage } from '../context/LanguageContext'
import ukFlag from '../assets/flag-uk.svg'
import ilFlag from '../assets/flag-il.svg'
import logo from '../assets/logo.png'

import '../styles/Navbar.css'
const Navbar = ({ husbandFirstName, wifeFirstName }) => {
  const { user, logout } = useAppContext()
  const { language, toggleLanguage } = useLanguage()
  const navigate = useNavigate()

  const location = useLocation()
  const isRsvpRoute = location.pathname.startsWith('/rsvp')

  const [menuOpen, setMenuOpen] = useState(false)

  const handleLogout = () => {
    localStorage.removeItem('adminToken')
    localStorage.removeItem('adminUsername')
    localStorage.removeItem('adminTokenExpiry')
    logout()
    navigate('/admin-login')
    setMenuOpen(false)
  }

  const handleLogoClick = () => {
    if (user) {
      navigate('/admin')
    }
  }

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuOpen && !event.target.closest('.menu-container-navbar')) {
        setMenuOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [menuOpen])

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <div className="navbar-brand" onClick={handleLogoClick} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}>
          <img src={logo} alt="Invitly Logo" className="navbar-logo" />
          <span className="navbar-title">INVITLY </span>
        </div>

        {/* {wifeFirstName && (
          <span className="navbar-couple-names">
            {wifeFirstName} &amp; {husbandFirstName}
          </span>
        )} */}
      </div>
      <div className="navbar-right">
        {/* Language toggle */}
        <button onClick={toggleLanguage} className="language-toggle-navbar">
          <img
            src={language === 'en' ? ilFlag : ukFlag}
            alt={language === 'en' ? 'Hebrew Flag' : 'English Flag'}
            className="flag-icon-navbar"
          />
          <span className="language-text-navbar">
            {language === 'en' ? 'עברית' : 'English'}
          </span>
        </button>

        {user && !isRsvpRoute && (
          <div className="menu-container-navbar">
            <button
              className={`menu-button-navbar${menuOpen ? ' is-open' : ''}`}
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Menu"
            >
              <div className="hamburger-icon-navbar">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </button>

            {menuOpen && (
              <div className="menu-dropdown-navbar">
                <button
                  className="menu-item-navbar"
                  onClick={() => { navigate('/settings'); setMenuOpen(false) }}
                >
                  <svg className="menu-icon-navbar" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <circle cx="12" cy="12" r="3"/>
                    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>
                  </svg>
                  Settings
                </button>
                {/* <button
                  className="menu-item-navbar"
                  onClick={() => { navigate('/gifts'); setMenuOpen(false) }}
                >
                  <svg className="menu-icon-navbar" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="20 12 20 22 4 22 4 12"/>
                    <rect x="2" y="7" width="20" height="5"/>
                    <line x1="12" y1="22" x2="12" y2="7"/>
                    <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/>
                    <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/>
                  </svg>
                  Gifts
                </button> */}
                <div className="menu-divider-navbar" />
                <button
                  className="menu-item-navbar logout-item"
                  onClick={handleLogout}
                >
                  <svg className="menu-icon-navbar" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                    <polyline points="16 17 21 12 16 7"/>
                    <line x1="21" y1="12" x2="9" y2="12"/>
                  </svg>
                  Logout
                </button>
              </div>
            )}
          </div>
        )}
      </div>
    </nav>
  )
}

export default Navbar
